<usb-base-modal
  [title]="title"
  [subtitle]="subtitle"
  [message]="message"
  [confirmText]="confirmText"
  [cancelText]="cancelText"
  [showCancelButton]="showCancelButton"
  [size]="size"
  [titleReverse]="titleReverse"
  [icon]="icon"
>
  <div class="not-found-container mb-2">
    <h2 class="not-found-title">No se Encontraron <br /> Resultados.</h2>
    <div class="d-flex align-items-center not-found-copy-search" (click)="copySearch()">
      <img
        style="
          filter: invert(88%) sepia(18%) saturate(749%) hue-rotate(86deg) brightness(101%) contrast(92%);
        "
        width="25"
        height="25"
        src="../../../../assets/icons/search-result/busqueda-01.svg"
      />

      Copiar Búsqueda
    </div>
  </div>
</usb-base-modal>
